import scrollSpy from './components/scrollspy';

scrollSpy.init();
